import React from "react";
import { FormProvider } from "react-hook-form";
import { Edit } from "@refinedev/mui";

import { StoreForm } from "@modules/stores/components/StoreForm";
import { useStoreEditForm } from "./controller";

export const StoreEdit = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending, formLoading, id } = useStoreEditForm();

  return (
    <Edit
      recordItemId={id}
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
      isLoading={formLoading}
    >
      <FormProvider {...methods}>
        <StoreForm />
      </FormProvider>
    </Edit>
  );
});
